// extracted by css-extract-rspack-plugin
export default {"button":"_18cee31f","small":"_f8283896","large":"_26bcb5f4"};